import { renderOpenVacancyForm } from './open-form'
import { data, initializedContainers, popup } from './store'
import { renderVacancy, vacancyForm } from './vacancy'
import { renderVacancies } from './vancancies'

export async function init() {
  data.vacancies = await fetch(
    `https://${ZC_HANDLE}.cockpit.recruitnow.${ZC_DOMAIN}/jobsite/api/vacancies/feed/website?type=json`,
  ).then((res) => res.json())

  await Promise.all([initVacancies(), initVacancyForms(), initOpenVacancyForms()])
}

async function initVacancies() {
  const containers = [...document.querySelectorAll('[data-vbzc-vacancies]')]
  for (const container of containers) {
    if (!(container instanceof HTMLElement)) {
      return
    } else if (initializedContainers.has(container)) {
      return
    }

    container.classList.add('vbzc-root')
    renderVacancies(container)
    initializedContainers.add(container)

    const queryString = new URLSearchParams(window.location.search)
    if (queryString.has('vacancy')) {
      const id = queryString.get('vacancy')
      const vacancy = data.vacancies.find((vacancy) => vacancy.Id === id)
      if (vacancy) {
        await renderVacancy(vacancy, popup.clear().elements.container)
        popup.show()
      }
    }
  }

  window.addEventListener('popstate', async () => {
    const queryString = new URLSearchParams(window.location.search)
    if (queryString.has('vacancy')) {
      const id = queryString.get('vacancy')
      const vacancy = data.vacancies.find((vacancy) => vacancy.Id === id)
      if (vacancy) {
        await renderVacancy(vacancy, popup.clear().elements.container)
        popup.show()
      } else {
        popup.hide()
      }
    } else {
      popup.hide()
    }
  })
}

async function initVacancyForms() {
  const containers = [...document.querySelectorAll('[data-vbzc-vacancy-form]')]
  for (const container of containers) {
    if (!(container instanceof HTMLElement)) {
      return
    } else if (initializedContainers.has(container)) {
      return
    }

    container.classList.add('vbzc-root')
    initializedContainers.add(container)
    const form = await vacancyForm(container.dataset.vbzcVacancyForm!)
    container.append(form)
  }
}

async function initOpenVacancyForms() {
  const containers = [...document.querySelectorAll('[data-vbzc-open-form]')]
  for (const container of containers) {
    if (!(container instanceof HTMLElement)) {
      return
    } else if (initializedContainers.has(container)) {
      return
    }

    container.classList.add('vbzc-root')
    initializedContainers.add(container)
    await renderOpenVacancyForm(container)
  }
}
